const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45 24.5454V-5.34742C37.3617 -2.13313 28.1455 3.45388 21.9565 10.6948C12.226 22.0909 17.6435 28.1688 25.311 28.9286C24.9779 29.6182 24.6799 30.2026 24.4578 30.6292C24.2357 31.0558 23.8149 31.7513 23.3766 32.5286C14.1838 32.6045 8.35714 22.9734 15.6273 12.3721C22.2487 2.69999 35.3279 -6.03703 45 -11.5714H0V19.7883C4.01133 17.4189 8.36949 15.6934 12.9156 14.6747V14.6747C12.3934 15.7786 11.9823 16.9316 11.6883 18.1169C7.61368 18.6474 3.66025 19.873 0 21.7402L0 51.5454C6.75584 48.2961 15.7792 43.4396 22.0208 36.1169C31.7513 24.7266 26.3338 18.6428 18.6662 17.8889C18.9994 17.1993 19.2974 16.6149 19.5195 16.1941C19.7416 15.7734 20.1682 15.0662 20.624 14.2889C29.8052 14.2071 35.6493 23.8325 28.3734 34.4337C22.05 43.65 9.21623 52.5039 0 58.0032C1.01688 58.0032 45 57.4188 45 57.4188V26.4448C40.7097 29.1189 35.9967 31.0456 31.0617 32.1428V32.1428C31.59 31.0437 32.0071 29.8945 32.3065 28.7123C36.7569 28.1114 41.0593 26.6991 45 24.5454V24.5454Z",
  fill: "url(#paint0_linear)"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -2.31429,
  y1: 44.3688,
  x2: 44.1818,
  y2: 4.16686,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "white",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "white",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "white",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 45,
  fill: "white"
})));
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bd42859c955b925977fe26566c9ed904.svg";
export { ForwardRef as ReactComponent };